import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInput } from '@/models/app';

export const fetchServiceSurveys = async ({ service, pagination }: { service?: string; pagination: PaginationInput }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      service,
      pagination,
    },
    query: graphql(`
      query ServiceSurveys($service: String, $pagination: PaginationInputType) {
        serviceSurveys(service: $service, pagination: $pagination) {
          count
          rows {
            id
            service
            dateOfService
            phoneNumber
            email
            callerId
            operatorId
            data {
              question
              value
              answers
              details {
                statement
                value
              }
            }
            notes
            caller {
              firstName
              lastName
              timeZone
              phoneNumber
              email
            }
            operator {
              firstName
              lastName
            }
            createdAt
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.serviceSurveys!;
};
